<template>
  <div
    v-if="isStaff && articleId != null"
    class="article-staff-edit-bar"
  >
    <UiButton
      class="article-staff-edit-bar__btn"
      data-test="articles-sights-btn-more"
      :size="UiButtonSize.S"
      :variant="UiButtonVariant.OUTLINE"
      :color-mode="UiButtonColorMode.INVERTED"
      target="_blank"
      icon-position="left"
      text="Редактировать статью"
      :href="adminLink"
    />
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import { getBootstrapData } from '@experience/core-hostapp-share-lib';
  import { UiButton, UiButtonVariant, UiButtonColorMode, UiButtonSize } from '@experience/core-button-ui';

  const props = defineProps<{
    articleId?: number | null;
  }>();

  const { isStaff } = getBootstrapData();

  const adminLink = computed(() => `/backoffice/articles/${props.articleId}`);
</script>

<style lang="scss" scoped>
  .article-staff-edit-bar {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 12px;
    background-color: var(--alias-color-background-inverse);
  }

  .article-staff-edit-bar__btn {
    margin: 0 auto;
  }
</style>
